module.exports = __webpack_public_path__ + "img/60m2.c1fdea7f.jpg";